import styled from "styled-components";

export const AmbientModeLightsDefaultBox = styled.div`
    position: absolute;
    width: 160%;
    height: 160%;
    /* Allow clicks to go through */
    pointer-events: none;
`;
